/**
 * ANQ.ContentServiceManagement.API 
 * Content Service Mgt API
 *
 * OpenAPI spec version: v1
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ProblemDetails } from '../model/problemDetails';
import { SubscriberIndustryDndStatus } from '../model/subscriberIndustryDndStatus';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class IndustryDndService {

    protected basePath = '/';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param subscriberPhoneNumber 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiIndustryDndGetSubscribersIndustryDndStatusGet(subscriberPhoneNumber?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<SubscriberIndustryDndStatus>>;
    public apiIndustryDndGetSubscribersIndustryDndStatusGet(subscriberPhoneNumber?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<SubscriberIndustryDndStatus>>>;
    public apiIndustryDndGetSubscribersIndustryDndStatusGet(subscriberPhoneNumber?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<SubscriberIndustryDndStatus>>>;
    public apiIndustryDndGetSubscribersIndustryDndStatusGet(subscriberPhoneNumber?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (subscriberPhoneNumber !== undefined && subscriberPhoneNumber !== null) {
            queryParameters = queryParameters.set('subscriberPhoneNumber', <any>subscriberPhoneNumber);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<SubscriberIndustryDndStatus>>('get',`${this.basePath}/api/IndustryDnd/GetSubscribersIndustryDndStatus`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param body 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public apiIndustryDndProcessIndustryDndSubscriptionPost(body?: SubscriberIndustryDndStatus, observe?: 'body', reportProgress?: boolean): Observable<SubscriberIndustryDndStatus>;
    public apiIndustryDndProcessIndustryDndSubscriptionPost(body?: SubscriberIndustryDndStatus, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<SubscriberIndustryDndStatus>>;
    public apiIndustryDndProcessIndustryDndSubscriptionPost(body?: SubscriberIndustryDndStatus, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<SubscriberIndustryDndStatus>>;
    public apiIndustryDndProcessIndustryDndSubscriptionPost(body?: SubscriberIndustryDndStatus, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {


        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<SubscriberIndustryDndStatus>('post',`${this.basePath}/api/IndustryDnd/ProcessIndustryDndSubscription`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
